
import { apiHelper } from "../apiHelper/apiHelper";
import {
  getConsultantsFailure,
  getConsultantsRequest,
  getConsultantsSuccess,
  getConsultantDetailsFailure,
  getConsultantDetailsRequest,
  getConsultantDetailsSuccess,
  getNearByUsersFailure,
  getNearByUsersRequest,
  getNearByUsersSuccess,
  deleteConsultantRequest,
  deleteConsultantSuccess,
  deleteConsultantFailure,
} from "../slices/consultantsSlices";

// ========================== NEW API HANDLER =================

// get Farmers list
export const handleGetConsultantList = () => async (dispatch) => {
  const endPoint = "consultant/";
  const method = "GET";
  const state1 = getConsultantsRequest;
  const state2 = getConsultantsSuccess;
  const state3 = getConsultantsFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

// get Farmers list
export const handleGetConsultantDetails = (consultantId) => async (dispatch) => {
  const endPoint = `consultant/${consultantId}`;
  const method = "GET";
  const state1 = getConsultantDetailsRequest;
  const state2 = getConsultantDetailsSuccess;
  const state3 = getConsultantDetailsFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
 
};


// delete Supplier
export const handleDeleteConsultant = (consultantId) => async (dispatch) => {
  const endPoint = `consultant/${consultantId}`;  // Supplier ID is appended to the endpoint
  const method = "DELETE";  // Use DELETE method to remove the supplier
  
  const state1 = deleteConsultantRequest; // Request state action (loading)
  const state2 = deleteConsultantSuccess; // Success state action
  const state3 = deleteConsultantFailure; // Failure state action
  const isToast = false; // Toast disabled (can be enabled if you wish)
  const isFile = false; // No file upload involved
  const isToken = true; // Include authentication token

  // Call apiHelper, passing dispatch correctly
  await apiHelper(
    endPoint,
    method,
    null,  // No body required for DELETE
    state1,
    state2,
    state3,
    dispatch,  // Ensure dispatch is passed properly
    isFile,
    isToast,
    isToken
  );
};


// get Farmers list
export const handleGetNearConsultantList = (role, latitude, longitude, page, limit) => async (dispatch) => {
  const endPoint = `user/nearby?role=${role}&latitude=${latitude}&longitude=${longitude}&page=${page}&limit=${limit}`;
  const method = "GET";
  const state1 = getNearByUsersRequest;
  const state2 = getNearByUsersSuccess;
  const state3 = getNearByUsersFailure;
  const isToast = false;
  const isFile = false;
  const isToken = false;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};